// routes
import { PATH_DASHBOARD } from './routes/paths';
import { getRuntimeEnv } from './utils/runtimeEnv';

// API
// ----------------------------------------------------------------------

// dev 模式下走同源 (由 src/setupProxy.js 把 /v1 和 /backyard 转发到后端), 绕过 CORS。
// 生产构建仍读 REACT_APP_HOST_API_KEY (可被 public/runtime-env.js 覆盖)。
export const HOST_API_KEY =
  process.env.NODE_ENV === 'development' ? '' : getRuntimeEnv('REACT_APP_HOST_API_KEY')
export const COPY_URL = getRuntimeEnv('REACT_APP_COPY_URL')

export const FIREBASE_API = {
  apiKey: getRuntimeEnv('REACT_APP_FIREBASE_API_KEY'),
  authDomain: getRuntimeEnv('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: getRuntimeEnv('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: getRuntimeEnv('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getRuntimeEnv('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getRuntimeEnv('REACT_APP_FIREBASE_APPID'),
  measurementId: getRuntimeEnv('REACT_APP_FIREBASE_MEASUREMENT_ID'),
}

export const COGNITO_API = {
  userPoolId: getRuntimeEnv('REACT_APP_AWS_COGNITO_USER_POOL_ID'),
  clientId: getRuntimeEnv('REACT_APP_AWS_COGNITO_CLIENT_ID'),
}

export const AUTH0_API = {
  clientId: getRuntimeEnv('REACT_APP_AUTH0_CLIENT_ID'),
  domain: getRuntimeEnv('REACT_APP_AUTH0_DOMAIN'),
}

export const MAP_API = getRuntimeEnv('REACT_APP_MAPBOX_API')

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.home;

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const NAV = {
  W_BASE: 260,
  W_LARGE: 320,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
